import {Component, Input, OnInit} from '@angular/core';
import {
  SortListModel,
  SortOrderEnum
} from '../../../../../search/search-list/results/pagination/sort-list/sort-list.model';
import {Filter} from "../../../../../search/search-list/filters/filter-block/filter-item/filter";
import {TranslateService} from "../../../../translate.service";
import {AppUtils} from "../../../../app-utils";
import {ActivatedRoute, Router} from "@angular/router";
import {HtmlUtilsService} from "../../../../../html-utils/html-utils.service";
import {RichSearchList} from "../../../../../search/search-list/rich-search-list";
import {SearchService} from "../../../../../search/search.service";
import {QueryParams} from "../../../query-params.model";
import {FacetService} from "../../../facets/facet.service";
import {ListService} from "../../../list.service";

@Component({
  selector: 'app-sort',
  templateUrl: './sort.component.html',
  styleUrls: ['./sort.component.scss']
})
export class SortComponent implements OnInit {

  @Input() facets: Filter[];

  @Input() useGlobalOmnisStyle = false;

  sortFields: SortListModel[] = [];

  selectedField: SortListModel;

  constructor(private searchService: SearchService,
              private router: Router,
              private activatedRoute: ActivatedRoute,
              private facetService: FacetService,
              private translator: TranslateService,
              private listService: ListService) {
  }

  ngOnInit() {
    this.populateSortList(this.searchService.searchList);
    this.setSelectedField();
    this.searchService.searchListEmitter.subscribe(() => {
      this.populateSortList(this.searchService.searchList);
      this.setSelectedField();
    })
  }

  getOrderTranslate(sortOrder: SortOrderEnum , isDateType: boolean, isCharType: boolean): string {
    if (isCharType) {
      return this.translator.translate(sortOrder === SortOrderEnum.DESC ? 'SortOrderEnumChar.DESC' : 'SortOrderEnumChar.ASC');
    } else if(isDateType) {
      return this.translator.translate(sortOrder === SortOrderEnum.DESC ? 'SortOrderEnumTime.DESC' : 'SortOrderEnumTime.ASC');
    }
    return this.translator.translate(sortOrder === SortOrderEnum.DESC ? 'SortOrderEnum.DESC' : 'SortOrderEnum.ASC');
  }

  onSelect() {

    let oldQueryParams = SearchService.prepareParamsObject(this.activatedRoute.snapshot.queryParamMap, undefined);
    let queryParams = new QueryParams({});
    queryParams.phrase = this.searchService.searchList.phrase;
    queryParams.page = 1;
    queryParams.pageSize = this.searchService.searchList.pageSize;
    queryParams.filters = this.facetService.filtersToString();
    queryParams.searchInText = oldQueryParams.searchInText;

    if (this.selectedField) {
      if (this.selectedField.nestedField) {
        queryParams.sort = `${this.selectedField.field}:${this.selectedField.sortOrder}:${this.selectedField.nestedField}`;
      } else {
        queryParams.sort = `${this.selectedField.field}:${this.selectedField.sortOrder}`;
      }
    }

    let currentPage = AppUtils.getCurrentPage();
    queryParams.url = HtmlUtilsService.getSearchUrl(currentPage);
    this.listService.addEvent(queryParams);
  }

  private setSelectedField() {
    let sort = this.activatedRoute.snapshot.queryParams.sort;
    if (sort) {
      let split = sort.split(":");
      if (split && split.length > 1) {
        this.sortFields.forEach((sortfield) => {
          if (sortfield.field === split[0] && sortfield.sortOrder === split[1]) {
            this.selectedField = sortfield;
          }
        });
      }
    } else if (this.searchService.searchList.sortField){
      this.selectedField = this.sortFields.filter(value => this.searchService.searchList.sortField.lastIndexOf(value.field + ':' + value.sortOrder) >= 0)[0];
    } else {
      this.selectedField = this.sortFields.filter(value => value.field + ':' + value.sortOrder === '_score:desc')[0];
    }
  }

  private populateSortList(data: RichSearchList) {
    this.sortFields = [];
    this.addPairSortList("_score");
    let selectedObjects = data.filters.map(value => value.value);
    if (selectedObjects.includes('work') && selectedObjects.includes('museum_object')) {
      this.addPairSortList("creationTime", null, true);
      // this.addPairSortList("Data powstania", "todo");
    } else {
      if (selectedObjects.includes('work')) {
        this.addPairSortList("creationTime", null, true);
        // this.addPairSortList("work_time_created.from.year");
        this.addPairSortList("filter_pub_date", null, true);
        this.addPairSortList("work_title_pref",null, false, true);
        this.addPairSortList("work_presentation_main_creator.value.value", "work_presentation_main_creator", false, true);
      } else if (selectedObjects.includes('museum_object')) {
        this.addPairSortList("creationTime", null, true);
        // this.addPairSortList("Data powstania", "todo");
        this.addPairSortList("mus_object_title", null, false, true);
        this.addPairSortList("mus_object_creator", null, false, true);
      }
    }
  }

  private addPairSortList(field: string, nestedField?: string, isDateType?: boolean, isCharType?: boolean): void {
    this.sortFields.push(new SortListModel({
      name: this.translator.translate(field),
      field: field,
      sortOrder: SortOrderEnum.ASC,
      nestedField: nestedField,
      isDateType: isDateType,
      isCharType: isCharType
    }));
    this.sortFields.push(new SortListModel({
      name: this.translator.translate(field),
      field: field,
      sortOrder: SortOrderEnum.DESC,
      nestedField: nestedField,
      isDateType: isDateType,
      isCharType: isCharType
    }));
  }

}
